import { render } from "./ConfigDs.vue?vue&type=template&id=5d60ab6e&scoped=true&ts=true"
import script from "./ConfigDs.vue?vue&type=script&lang=ts"
export * from "./ConfigDs.vue?vue&type=script&lang=ts"

import "./ConfigDs.vue?vue&type=style&index=0&id=5d60ab6e&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d60ab6e"]])

export default __exports__